import React, { forwardRef } from 'react';
import Image from '../image/Image';
import cn from '../../utils/cn';
import IconUserRound from '../../icons/IconUserRound.tsx';
import IconStar from '../../icons/IconStar.tsx';

export enum AvatarVariant {
  DEFAULT,
  OUTLINE,
}

export type AvatarProps = {
  variant?: AvatarVariant;
  isConnected?: boolean;
  isFavorite?: boolean;
} & React.ComponentPropsWithoutRef<'img'>;

const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  (
    {
      variant = AvatarVariant.DEFAULT,
      isFavorite = false,
      isConnected,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        data-slot="avatar"
        className={cn(
          'relative size-10 shrink-0 rounded-full bg-white',
          {
            'p-0.5': variant === AvatarVariant.OUTLINE,
          },
          className,
        )}
      >
        <Image.Root {...props} className="rounded-full">
          <Image.Img />
          <Image.Loading />
          <Image.Error>
            <IconUserRound className="fill-neutral-200" />
          </Image.Error>
        </Image.Root>

        {isConnected !== undefined ? (
          <div className="absolute -right-1 bottom-0 size-4 rounded-full bg-white p-0.5">
            <div
              className={cn('size-full rounded-full bg-red-500', {
                'bg-green-500': isConnected,
              })}
              data-connected={isConnected}
            />
          </div>
        ) : null}

        {isFavorite ? (
          <IconStar className="absolute -left-1 top-px size-4 overflow-visible fill-yellow-500 stroke-white stroke-[3px]" />
        ) : null}
      </div>
    );
  },
);

Avatar.displayName = 'Avatar';

export default Avatar;
